import React from 'react'

const scoreCardIcons = {
  English:
    'https://cdn.builder.io/api/v1/image/assets/d84e059b57274e6aae99b9cca7cfff8b/047d30d9318257bc37c5aaebe601fe0732c86e02?placeholderIfAbsent=true',
  Mathematics:
    'https://cdn.builder.io/api/v1/image/assets/d84e059b57274e6aae99b9cca7cfff8b/3beed9daf6fbb4f20cb3b8bf8cac754d531f4e8e?placeholderIfAbsent=true',
  Science:
    'https://cdn.builder.io/api/v1/image/assets/d84e059b57274e6aae99b9cca7cfff8b/c1f5cf3ff8abe216d50393a52faf659cc9ffdb12?placeholderIfAbsent=true',
}

// Replace the Total Score icon for SAT with the provided SVG
const SatTotalScoreIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M16.0318 17.9961C15.3571 18.0013 15.0095 17.1592 15.4993 16.6869C20.7778 11.6289 17.0621 2.50053 9.74905 2.54764C2.43642 2.50144 -1.27998 11.6287 3.99928 16.687C4.69729 17.4171 3.68382 18.4591 2.93413 17.7796C-0.937974 14.1232 -0.987562 7.58742 2.84437 3.8819C10.6043 -3.57965 22.7746 4.67733 18.7212 14.6467C18.2132 15.8255 17.4875 16.8796 16.5642 17.7796C16.4219 17.9186 16.2308 17.9964 16.0318 17.9961ZM8.79558 5.02696C8.79558 5.55362 9.22254 5.98058 9.7492 5.98058C11.0131 5.9337 11.0122 4.11981 9.7492 4.07335C9.22254 4.07335 8.79558 4.5003 8.79558 5.02696ZM2.9976 10.7868C2.9976 11.3135 3.42455 11.7404 3.95121 11.7404C5.21514 11.6935 5.21418 9.87965 3.95121 9.83319C3.42455 9.83319 2.9976 10.2601 2.9976 10.7868ZM14.5554 10.7868C14.5554 11.3135 14.9824 11.7404 15.509 11.7404C16.773 11.6935 16.772 9.87965 15.509 9.83319C14.9824 9.83319 14.5554 10.2601 14.5554 10.7868ZM4.67596 6.74347C4.67596 7.27013 5.10292 7.69709 5.62958 7.69709C6.8935 7.65021 6.89255 5.83631 5.62958 5.78985C5.10292 5.78985 4.67596 6.21681 4.67596 6.74347ZM4.67596 14.8301C4.67596 15.3568 5.10292 15.7837 5.62958 15.7837C6.8935 15.7369 6.89255 13.923 5.62958 13.8765C5.10292 13.8765 4.67596 14.3035 4.67596 14.8301ZM12.8389 14.8301C12.8389 15.3568 13.2659 15.7837 13.7925 15.7837C15.0565 15.7369 15.0555 13.923 13.7925 13.8765C13.2659 13.8765 12.8389 14.3035 12.8389 14.8301ZM14.5203 5.97276C14.221 5.67618 13.738 5.67836 13.4414 5.9776L9.80775 9.64395C8.25298 9.62709 8.19595 11.8687 9.7492 11.9311C10.4051 11.9335 10.9331 11.3726 10.8913 10.7182L14.5251 7.05164C14.8217 6.7524 14.8195 6.26933 14.5203 5.97276Z"
      fill="#030303"
    />
  </svg>
)

// Replace the Reading & Writing icon for SAT with the provided SVG
const SatReadingWritingIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M15.5843 10.4633L13.7865 8.66558M9.29224 14.9576C9.29224 13.8066 9.74948 12.7027 10.5634 11.8887L15.3301 7.12208C15.8265 6.62565 16.6314 6.62565 17.1278 7.12208C17.6242 7.61851 17.6242 8.42339 17.1278 8.91979L12.3611 13.6865C11.9581 14.0895 11.4797 14.4092 10.9531 14.6273C10.4266 14.8454 9.86218 14.9576 9.29224 14.9576Z"
      stroke="#535862"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.9407 15.6928V16.2288C13.9407 16.9309 13.3715 17.5 12.6695 17.5H3.77119C3.06914 17.5 2.5 16.9309 2.5 16.2288V3.77119C2.5 3.06914 3.06914 2.5 3.77119 2.5H10.8717C11.0387 2.5 11.204 2.53287 11.3582 2.59676C11.5124 2.66064 11.6526 2.75428 11.7706 2.87233L13.5683 4.67004C13.7219 4.82354 13.8335 5.01382 13.8926 5.22272"
      stroke="#535862"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.04248 14.9576C5.04248 14.2556 5.61162 13.6864 6.31367 13.6864C7.01571 13.6864 7.58485 14.2556 7.58485 14.9576H9.29225M5.04248 6.31354H8.85604M5.04248 8.85591H8.85604"
      stroke="#535862"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)

// Replace the Mathematics icon for SAT with the provided SVG
const SatMathematicsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M15.4233 2.52036L4.6048 2.5C3.45625 2.49909 2.52382 3.42801 2.52036 4.57665L2.5 15.3952C2.49909 16.5437 3.42801 17.4762 4.57665 17.4796L15.3952 17.5C16.5437 17.5009 17.4762 16.5719 17.4796 15.4233L17.5 4.6048C17.5009 3.45625 16.5719 2.52382 15.4233 2.52036ZM9.5713 16.6568L4.57814 16.6475C3.88908 16.6454 3.33165 16.0859 3.33221 15.3968L3.34158 10.4035L9.5831 10.4153L9.5713 16.6568ZM9.58469 9.5831L3.34319 9.57133L3.35257 4.57817C3.35462 3.88911 3.91416 3.33168 4.60319 3.33224L9.59638 3.34161L9.58469 9.5831ZM16.6474 15.4219C16.6453 16.1109 16.0858 16.6684 15.3968 16.6678L10.4035 16.6584L10.4153 10.4169L16.6568 10.4287L16.6474 15.4219ZM16.6584 9.59641L10.4169 9.58472L10.4287 3.34322L15.4219 3.3526C16.1109 3.35465 16.6683 3.91419 16.6678 4.60322L16.6584 9.59641Z"
      fill="#535862"
    />
    <path
      d="M5.22083 6.87035L6.05303 6.87196L6.05145 7.70405C6.0511 7.93386 6.23696 8.12051 6.46676 8.12095C6.69657 8.12139 6.88319 7.93544 6.88366 7.70566L6.88527 6.87343L7.71748 6.87504C7.94728 6.87551 8.13393 6.68953 8.13437 6.45973C8.13481 6.22992 7.94886 6.04327 7.71909 6.04283L6.88685 6.04122L6.88835 5.20913C6.88881 4.97933 6.70284 4.79268 6.47303 4.79224C6.24323 4.7918 6.05661 4.97772 6.05614 5.20752L6.05467 6.03973L5.22244 6.03814C4.99263 6.03768 4.80598 6.22365 4.80554 6.45343C4.8051 6.6832 4.99102 6.86991 5.22083 6.87035ZM14.7927 6.0561L12.2961 6.05142C12.0663 6.05106 11.8797 6.23692 11.8792 6.46673C11.8788 6.69653 12.0648 6.88315 12.2945 6.88362L14.7911 6.88831C15.0209 6.88878 15.2075 6.7028 15.208 6.473C15.2084 6.24319 15.0225 6.05657 14.7927 6.0561ZM5.2776 14.7049C5.43961 14.8676 5.70299 14.8682 5.86583 14.7061L5.86606 14.7059L6.45551 14.1187L7.04286 14.7082C7.20777 14.8682 7.47118 14.864 7.6312 14.699C7.78729 14.5381 7.78773 14.2824 7.63234 14.1209L7.04502 13.5314L7.63448 12.9441C7.7945 12.779 7.79037 12.5156 7.62534 12.3557C7.46444 12.1996 7.20879 12.1992 7.04731 12.3546L6.45771 12.9419L5.8704 12.3524C5.70548 12.1924 5.44205 12.1966 5.28206 12.3616C5.12608 12.5225 5.12549 12.7782 5.28103 12.9397L5.86823 13.5292L5.27875 14.1165C5.116 14.2787 5.11547 14.542 5.2776 14.7049ZM12.2797 14.7895L14.7763 14.7942C15.0061 14.7947 15.1927 14.6087 15.1932 14.3789C15.1936 14.1491 15.0076 13.9625 14.7778 13.962L12.2813 13.9574C12.0515 13.9569 11.8648 14.1428 11.8644 14.3726C11.8639 14.6024 12.0499 14.7891 12.2797 14.7895ZM12.2827 13.1251L14.7794 13.1298C15.0092 13.1303 15.1959 12.9443 15.1963 12.7145C15.1967 12.4847 15.0108 12.298 14.781 12.2976L12.2843 12.2929C12.0546 12.2926 11.8679 12.4784 11.8674 12.7082C11.8671 12.938 12.0529 13.1246 12.2827 13.1251Z"
      fill="#535862"
    />
  </svg>
)

// Replace the English icon with the provided SVG
const EnglishIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.625 2.6875C2.50897 2.6875 2.39769 2.73359 2.31564 2.81564C2.23359 2.89769 2.1875 3.00897 2.1875 3.125V11.875C2.1875 12.1165 2.3835 12.3125 2.625 12.3125H11.375C11.491 12.3125 11.6023 12.2664 11.6844 12.1844C11.7664 12.1023 11.8125 11.991 11.8125 11.875V3.125C11.8125 3.00897 11.7664 2.89769 11.6844 2.81564C11.6023 2.73359 11.491 2.6875 11.375 2.6875H2.625ZM1.3125 3.125C1.3125 2.7769 1.45078 2.44306 1.69692 2.19692C1.94306 1.95078 2.2769 1.8125 2.625 1.8125H11.375C11.7231 1.8125 12.0569 1.95078 12.3031 2.19692C12.5492 2.44306 12.6875 2.7769 12.6875 3.125V11.875C12.6875 12.2231 12.5492 12.5569 12.3031 12.8031C12.0569 13.0492 11.7231 13.1875 11.375 13.1875H2.625C2.2769 13.1875 1.94306 13.0492 1.69692 12.8031C1.45078 12.5569 1.3125 12.2231 1.3125 11.875V3.125Z"
      fill="#030303"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.35425 5.45825C3.35425 5.34222 3.40034 5.23094 3.48239 5.14889C3.56444 5.06685 3.67572 5.02075 3.79175 5.02075H6.12508C6.24111 5.02075 6.35239 5.06685 6.43444 5.14889C6.51649 5.23094 6.56258 5.34222 6.56258 5.45825C6.56258 5.57428 6.51649 5.68556 6.43444 5.76761C6.35239 5.84966 6.24111 5.89575 6.12508 5.89575H4.22925V9.54159C4.22925 9.65762 4.18315 9.7689 4.10111 9.85095C4.01906 9.93299 3.90778 9.97909 3.79175 9.97909C3.67572 9.97909 3.56444 9.93299 3.48239 9.85095C3.40034 9.7689 3.35425 9.65762 3.35425 9.54159V5.45825Z"
      fill="#030303"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.35425 7.50008C3.35425 7.38405 3.40034 7.27277 3.48239 7.19072C3.56444 7.10868 3.67572 7.06258 3.79175 7.06258H5.97925C6.09528 7.06258 6.20656 7.10868 6.28861 7.19072C6.37065 7.27277 6.41675 7.38405 6.41675 7.50008C6.41675 7.61611 6.37065 7.72739 6.28861 7.80944C6.20656 7.89149 6.09528 7.93758 5.97925 7.93758H3.79175C3.67572 7.93758 3.56444 7.89149 3.48239 7.80944C3.40034 7.72739 3.35425 7.61611 3.35425 7.50008ZM3.35425 9.54175C3.35425 9.42572 3.40034 9.31444 3.48239 9.23239C3.56444 9.15034 3.67572 9.10425 3.79175 9.10425H5.97925C6.09528 9.10425 6.20656 9.15034 6.28861 9.23239C6.37065 9.31444 6.41675 9.42572 6.41675 9.54175C6.41675 9.65778 6.37065 9.76906 6.28861 9.85111C6.20656 9.93315 6.09528 9.97925 5.97925 9.97925H3.79175C3.67572 9.97925 3.56444 9.93315 3.48239 9.85111C3.40034 9.76906 3.35425 9.65778 3.35425 9.54175ZM7.58341 5.60425C7.69945 5.60425 7.81073 5.65034 7.89277 5.73239C7.97482 5.81444 8.02091 5.92572 8.02091 6.04175V9.54175C8.02091 9.65778 7.97482 9.76906 7.89277 9.85111C7.81073 9.93315 7.69945 9.97925 7.58341 9.97925C7.46738 9.97925 7.3561 9.93315 7.27406 9.85111C7.19201 9.76906 7.14591 9.65778 7.14591 9.54175V6.04175C7.14591 5.92572 7.19201 5.81444 7.27406 5.73239C7.3561 5.65034 7.46738 5.60425 7.58341 5.60425Z"
      fill="#030303"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.89575 6.77075C8.66369 6.77075 8.44113 6.86294 8.27703 7.02703C8.11294 7.19113 8.02075 7.41369 8.02075 7.64575V9.54159C8.02075 9.65762 7.97466 9.7689 7.89261 9.85095C7.81056 9.93299 7.69928 9.97909 7.58325 9.97909C7.46722 9.97909 7.35594 9.93299 7.27389 9.85095C7.19185 9.7689 7.14575 9.65762 7.14575 9.54159V7.64575C7.14575 7.18162 7.33013 6.7365 7.65831 6.40831C7.9865 6.08013 8.43162 5.89575 8.89575 5.89575C9.35988 5.89575 9.805 6.08013 10.1332 6.40831C10.4614 6.7365 10.6458 7.18162 10.6458 7.64575V9.54159C10.6458 9.65762 10.5997 9.7689 10.5176 9.85095C10.4356 9.93299 10.3243 9.97909 10.2083 9.97909C10.0922 9.97909 9.98094 9.93299 9.89889 9.85095C9.81685 9.7689 9.77075 9.65762 9.77075 9.54159V7.64575C9.77075 7.41369 9.67856 7.19113 9.51447 7.02703C9.35038 6.86294 9.12782 6.77075 8.89575 6.77075Z"
      fill="#030303"
    />
  </svg>
)

const ScoreCard = ({
  subject,
  score,
  maxScore,
  iconSrc,
  isTotal,
  isReading,
}) => (
  <div
    className={`flex flex-col items-center justify-center bg-neutral-50 border border-[#F0F0F0] rounded-[16px] shadow-sm ${
      isTotal ? 'text-[#DE3C7D]' : 'text-[#4E57EF]'
    }`}
    style={{
      flex: 1,
      minWidth: 0,
      margin: '0 13px',
      padding: '26px 0',
      maxWidth: '100%',
      minHeight: 128,
      height: '100%',
    }}
  >
    <div className="flex items-center gap-2 mb-3">
      <div className="flex items-center justify-center w-9 h-9 bg-white border border-[#F0F0F0] rounded-full">
        {isTotal ? (
          <SatTotalScoreIcon />
        ) : isReading ? (
          <SatReadingWritingIcon />
        ) : iconSrc ? (
          <img src={iconSrc} className="w-5 h-5 object-contain" alt={subject} />
        ) : (
          <SatMathematicsIcon />
        )}
      </div>
      <div className="text-[#030303] text-base font-semibold tracking-[-0.08px]">
        {subject}
      </div>
    </div>
    <div className="flex items-end gap-1">
      <div
        className={`${isTotal ? 'text-[#DE3C7D]' : 'text-[#4E57EF]'} font-bold`}
        style={{ fontSize: 45 }}
      >
        {score}
      </div>
      <div className="text-[#535862] text-sm font-medium pb-1">{maxScore}</div>
    </div>
  </div>
)

const ScoreCards = ({ scores, mode }) => {
  if (mode === 'sat') {
    return (
      <div
        className="flex w-full gap-6 flex-nowrap justify-between items-stretch mt-8"
        style={{ minWidth: 0 }}
      >
        {/* Reading & Writing Score */}
        <div
          className="flex items-center bg-neutral-50 border border-[#F0F0F0] rounded-[16px] shadow-sm flex-1 min-w-0 max-w-full"
          style={{
            minHeight: 88,
            height: 88,
            padding: '0 32px',
            justifyContent: 'space-between',
          }}
        >
          <div className="flex items-center justify-center w-12 h-12 bg-white border border-[#F0F0F0] rounded-full mr-4">
            <SatReadingWritingIcon />
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-[#030303] text-lg font-semibold tracking-[-0.08px] text-left">
              Reading & Writing Score
            </div>
          </div>
          <div className="flex items-end gap-1 ml-4">
            <span
              className="text-[2.25rem] font-bold text-[#4E57EF] leading-none"
              style={{ fontSize: 40 }}
            >
              {scores.English}
            </span>
            <span className="text-[#535862] text-base font-medium pb-1">
              /800
            </span>
          </div>
        </div>
        {/* Total Score */}
        <div
          className="flex items-center bg-neutral-50 border border-[#F0F0F0] rounded-[16px] shadow-sm flex-1 min-w-0 max-w-full"
          style={{
            minHeight: 88,
            height: 88,
            padding: '0 32px',
            justifyContent: 'space-between',
          }}
        >
          <div className="flex items-center justify-center w-12 h-12 bg-white border border-[#F0F0F0] rounded-full mr-4">
            <SatTotalScoreIcon />
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-[#030303] text-lg font-semibold tracking-[-0.08px] text-left">
              Total Score
            </div>
          </div>
          <div className="flex items-end gap-1 ml-4">
            <span
              className="text-[2.25rem] font-bold text-[#DE3C7D] leading-none"
              style={{ fontSize: 40 }}
            >
              {scores.Total}
            </span>
            <span className="text-[#535862] text-base font-medium pb-1">
              /1600
            </span>
          </div>
        </div>
        {/* Mathematics Score */}
        <div
          className="flex items-center bg-neutral-50 border border-[#F0F0F0] rounded-[16px] shadow-sm flex-1 min-w-0 max-w-full"
          style={{
            minHeight: 88,
            height: 88,
            padding: '0 32px',
            justifyContent: 'space-between',
          }}
        >
          <div className="flex items-center justify-center w-12 h-12 bg-white border border-[#F0F0F0] rounded-full mr-4">
            <SatMathematicsIcon />
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-[#030303] text-lg font-semibold tracking-[-0.08px] text-left">
              Mathematics Score
            </div>
          </div>
          <div className="flex items-end gap-1 ml-4">
            <span
              className="text-[2.25rem] font-bold text-[#4E57EF] leading-none"
              style={{ fontSize: 40 }}
            >
              {scores.Math}
            </span>
            <span className="text-[#535862] text-base font-medium pb-1">
              /800
            </span>
          </div>
        </div>
      </div>
    )
  }
  return (
    <div
      className="flex w-full gap-6 flex-nowrap justify-between items-stretch mt-8"
      style={{ minWidth: 0 }}
    >
      <ScoreCard
        subject="English"
        score={scores.English}
        maxScore="1-36"
        iconSrc={scoreCardIcons.English}
      />
      <ScoreCard
        subject="Mathematics"
        score={scores.Math}
        maxScore="1-36"
        iconSrc={scoreCardIcons.Mathematics}
      />
      <ScoreCard
        subject="Total Score"
        score={scores.Total}
        maxScore="1-36"
        isTotal={true}
      />
      <ScoreCard
        subject="Reading"
        score={scores.Reading}
        maxScore="1-36"
        isReading={true}
      />
      <ScoreCard
        subject="Science"
        score={scores.Science}
        maxScore="36"
        iconSrc={scoreCardIcons.Science}
      />
    </div>
  )
}

export default ScoreCards
